import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export const getQuoteProductClassesListAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SPOT_QUOTE_V2}/options/hazardous-classes`,
  });
};

export type QuoteProductClassesListResponse = {
  codeDesc: string;
  codeId: string;
}[];

export const fetchQuoteProductClassesList = async (): Promise<QuoteProductClassesListResponse> => {
  const response: AxiosResponse<QuoteProductClassesListResponse> = await getQuoteProductClassesListAPI();
  return response.data;
};
